
export const Hero = (props) => {
  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col intro-text">
                <h1>
                  {props.data ? props.data.title : "Loading"}
                  <span></span>
                </h1>
                <h2 className="text-white">
                  {props.data ? props.data.subTitle : "Loading"}
                  <span></span>
                </h2>
                <p>{props.data ? props.data.paraOne : "Loading"}</p>
                <p>{props.data ? props.data.paraTwo : "Loading"}</p>
                <a
                  href="#features"
                  className="btn btn-custom btn-lg page-scroll"
                >
                  Learn More
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
